import { ConnectedPosition } from '@angular/cdk/overlay';
import { Automation } from '../../builder.types';
import { Directive, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OverlayHelperComponent } from 'app/shared/components/overlay-helper/overlay-helper.component';
import { CustomObject } from 'app/shared/modules/custom-objects/custom-objects.types';
import { Store } from '@ngxs/store';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';

@Directive()
export abstract class CardBase {
  @Input() automation: Automation;
  @Output() open = new EventEmitter<number>();
  @ViewChild('overlayHelper') private overlayHelper: OverlayHelperComponent;

  position: ConnectedPosition = { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' };
  objects: CustomObject[] = [];

  constructor(protected readonly store: Store) {
    this.objects = this.store.selectSnapshot(ObjectsManagerState.get);
  }

  openSetup(index?: number): void {
    this.overlayHelper.close();
    this.open.emit(index);
  }
}
